<template>
  <div class="bg-gray p-2 evaluate-proposal">
    <div v-if="isEmailState" class="bg-white p-3">
      <section-title
        class="my-4"
        :has-line="false"
        icon="fas fa-bell"
        :reverse="true"
        title="Solicitud de Código de Acceso"
      />

      <validation-observer ref="evaluateProposal">
        <validation-provider v-slot="{ errors }" rules="required">
          <div class="row">
            <div class="row col-12 col-md-7">
              <div class="col-12 info mb-2">
                Seleccione el representante dentro del Centro de Evaluación para
                solicitar el Código de Acceso.
              </div>
              <div class="col-12 mt-3 justify-content-center">
                <custom-drop-down
                  v-model="evaluationCenter"
                  class="w-100"
                  custom-error-msg="Favor seleccionar el representante dentro del centro de evaluación para solicitar código de acceso."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="evaluationCenters"
                  placeholder="Seleccione"
                />
              </div>
            </div>

            <div class="row col-12 col-md-5 evaluate-proposal__actions-group">
              <action-button
                class="evaluate-proposal__action mr-1 mr-md-4"
                i="fa fa-times-circle"
                variant="outline-danger"
                @click="onCancelHandler"
              >
                Cancelar
              </action-button>
              <action-button
                class="evaluate-proposal__action"
                i="fas fa-chevron-circle-right"
                variant="success"
                @click="onAddHandler"
              >
                Continuar
              </action-button>
            </div>
          </div>
        </validation-provider>
      </validation-observer>
    </div>
    <div v-if="isValidateState" class="bg-white p-3">
      <section-title
        class="my-4"
        :has-line="false"
        icon="fas fa-bell"
        :reverse="true"
        title="Solicitud de Código de Acceso"
      />

      <validation-observer ref="evaluateTokenProposal">
        <validation-provider v-slot="{ errors }" rules="required">
          <div class="row">
            <div class="row col-12 col-md-6">
              <div class="col-12 info mb-2">Ingresar Código de Acceso:</div>
              <div class="col-12">
                <custom-input
                  v-model="token"
                  custom-error-msg="Favor ingresar código de acceso."
                  :error="errors[0]"
                  placeholder=""
                />
              </div>
            </div>

            <div class="row col-12 col-md-6 evaluate-proposal__actions-group">
              <action-button
                class="evaluate-proposal__action mr-1 mr-md-4"
                i="fa fa-times-circle"
                variant="outline-danger"
                @click="onCancelHandler"
              >
                Cancelar
              </action-button>
              <action-button
                class="evaluate-proposal__action"
                i="fas fa-chevron-circle-right"
                variant="success"
                @click="validationToken"
              >
                Continuar
              </action-button>
            </div>
          </div>
        </validation-provider>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import {
  getEvaluationCenters,
  sendEvaluationRequest,
  evaluatorVerifyCode,
} from '@/modules/serviceProposalHistory/api';
import alertMixin from 'utils/mixins/alert.mixin';
import CustomInput from 'CustomInput';
import proposalEvaluationStatus from '@/utils/constants/proposalEvaluationStatus.js';

export default {
  name: 'EvaluateProposal',
  components: {
    CustomInput,
    SectionTitle,
    CustomDropDown,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    proposalService: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    evaluationCenters: [],
    evaluationCenter: null,
    currentState: 'email',
    states: ['email', 'validation'],
    token: null,
  }),
  computed: {
    isEmailState() {
      return this.currentState === 'email';
    },
    isValidateState() {
      return this.currentState === 'validation';
    },
  },
  async mounted() {
    await this.initFilters();
  },
  methods: {
    async initFilters() {
      await getEvaluationCenters()
        .then(({ data }) => {
          this.evaluationCenter = null;
          this.evaluationCenters = [...data];
        })
        .catch((err) => {
          if (err.response != null)
            this.Toast(
              'Alerta',
              err.response.data.message || 'error',
              'error',
              5000
            );
        });
    },
    onCancelHandler() {
      this.$emit('close');
    },
    changeState(state) {
      if (this.states.includes(state)) {
        this.currentState = String(state);
        this.$refs.evaluateProposal.reset();
        this.$refs.evaluateTokenProposal.reset();
      }
    },
    async onAddHandler() {
      const isValid = await this.$refs.evaluateProposal.validate();
      if (!isValid) {
        this.Toast(
          'Alerta',
          'Favor completar la información para poder continuar.',
          'error'
        );
        return;
      }

      await sendEvaluationRequest(
        this.proposalService.proposalServiceId,
        this.evaluationCenter?.id
      )
        .then(() => {
          this.changeState('validation');
          this.Toast(
            'Confirmado',
            'Se ha enviado un correo electrónico al Representante Autorizado del Centro de Evaluación con el Código de Acceso para comenzar a evaluar la prouesta.',
            'success'
          );
        })
        .catch((err) => {
          if (err.response != null)
            this.Toast(
              'Alerta',
              err.response.data.message || 'error',
              'error',
              5000
            );
        });
    },
    async validationToken() {
      const isValid = await this.$refs.evaluateTokenProposal.validate();
      if (!isValid) {
        this.Toast('Alerta', 'Debe ingresar un código válido.', 'error');
        return;
      }

      await evaluatorVerifyCode(
        this.proposalService.proposalServiceId,
        this.token
      )
        .then((res) => {
          if (!res.data) {
            return;
          }

          if (res.data.key) {
            if (
              this.proposalService.proposalServiceStatusId ===
              proposalEvaluationStatus.EnProcesoEvaluacion
            ) {
              return this.$router.push({
                name: 'ServiceProposalEvaluation',
                params: {
                  proposalRequestId: this.proposalService.proposalRequestId,
                },
              });
            }
            this.$router.push({
              name: 'EvaluatorConflictsConfirmation',
              params: {
                proposalRequestId: this.proposalService.proposalRequestId,
                evaluationCenterId: this.evaluationCenter?.id,
              },
            });
          } else {
            this.Toast('Alerta', res.data.Value || 'error', 'error', 5000);
          }
        })
        .catch((err) => {
          if (err.response != null)
            this.Toast(
              'Alerta',
              err.response.data.message || 'error',
              'error',
              5000
            );
        });
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/fonts.scss';
@import '~@/shared/scss/config/colors.scss';

.label-input {
  font-weight: bold;
  font-size: 1.2rem;
  color: map-get($colors, 'black');
}

.label-info {
  font-weight: normal;
  font-size: 0.875rem;
  color: map-get($colors, 'secondary-6');
}

.info {
  font-weight: normal;
  color: map-get($colors, 'black');
}

.evaluate-proposal {
  &__actions-group {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;

    @media only screen and (min-width: 768px) {
      justify-content: flex-end;
      align-items: flex-end;
    }

    .evaluate-proposal__action {
      width: 49%;

      @media only screen and (min-width: 768px) {
        width: 125px;
        height: 2.5rem;
      }
    }
  }
}
</style>
